<template>
  <n-layout-header bordered v-if="!isMobile && isLoggedIn && !this.isCreateOrEditPlan">
    <NavBar v-if="this.isLoggedIn"></NavBar>
    <n-space :size="20" align="center" style="line-height: 1" v-if="this.adminIsLoggedInAsBasicUser">
      <n-button type="success" secondary @click="handleGoBackToAdmin">
        Volver a mi cuenta
      </n-button>
    </n-space>
    <n-space :size="20" align="center" style="line-height: 1" v-else>
      <n-button type="success" v-if="!this.isLoggedIn" @click="() => this.$router.push('/app/login')">
        Acceder
      </n-button>
      <n-button type="success" v-else @click="handleLogout">
        Cerrar sesión
      </n-button>
    </n-space>
  </n-layout-header>
  <!-- v-if is responsive -->
  <n-layout-header bordered v-else-if="isMobile && isLoggedIn" class="isMobile-RARO">
    <n-space justify-end>
      <i style="color: #2080F0" :class="!showSidebar ? 'icon-reorder icon-large' : 'icon-remove icon-large'"
        @click="alternateSidebar"></i>
    </n-space>
  </n-layout-header>
  <n-space justify="end" v-if="showSidebar"
    class="responsive-navbar d-flex flex-column align-items-center justify-content-start p-5">
    <div class="w-100 h-100 d-flex flex-column align-items-center" v-if="isAdmin">
      <n-h2 class="mobile-navbar-item" @click="this.mobileRedirect('/dashboard/admin')">Inicio</n-h2>
      <n-h2 class="mobile-navbar-item" @click="this.mobileRedirect('/providers/list')">Proveedores</n-h2>
      <n-h2 class="mobile-navbar-item" @click="this.mobileRedirect('/products/list')">Productos</n-h2>
      <n-h2 class="mobile-navbar-item" @click="this.mobileRedirect('/supplies/seed/list')">Semillas</n-h2>
      <n-h2 class="mobile-navbar-item" @click="alternateSupplies">Suministros</n-h2>
      <div class="d-flex flex-column align-items-center seed-gap">
        <n-h3 v-if="showSupplies" class="mobile-navbar-item"
          @click="this.mobileRedirect('/supplies/additives/list')">Aditivos</n-h3>
        <n-h3 v-if="showSupplies" class="mobile-navbar-item"
          @click="this.mobileRedirect('/supplies/fertilizer/list')">Fertilizantes</n-h3>
        <n-h3 v-if="showSupplies" class="mobile-navbar-item"
          @click="this.mobileRedirect('/supplies/fertilizerAndPhytosanitary/list')">Fertilizantes +
          Fitosanitarios</n-h3>
        <n-h3 v-if="showSupplies" class="mobile-navbar-item"
          @click="this.mobileRedirect('/supplies/phytosanitary/list')">Fitosanitarios</n-h3>
        <n-h3 v-if="showSupplies" class="mobile-navbar-item"
          @click="this.mobileRedirect('/supplies/phytosanitary/list')">Gasoil</n-h3>
      </div>
      <n-h2 class="mobile-navbar-item logout-button" @click="handleLogout">Cerrar sesión</n-h2>
    </div>
    <div class="w-100 h-100 d-flex flex-column align-items-center" v-else>
      <!-- <n-h2 class="mobile-navbar-item">Inicio</n-h2> -->
      <n-h2 class="mobile-navbar-item" @click="this.mobileRedirect('/plans/list')">Planes</n-h2>
      <n-h2 class="mobile-navbar-item logout-button" @click="handleLogout">Cerrar sesión</n-h2>
      <!-- add logout and login buttons -->
    </div>
  </n-space>


</template>

<script>
import { mapState, mapActions } from 'pinia';
import { defineComponent } from "vue";
import NavBar from '../navbar.vue'
import authStore from '../../store/auth';

export default defineComponent({
  name: 'HeaderLanding',
  components: {
    NavBar
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      showSidebar: false,
      showSupplies: false
    }
  },
  computed: {
    ...mapState(authStore, ['isAdmin', 'isLoggedIn', 'adminIsLoggedInAsBasicUser']),
    isMobile() {
      return this.windowWidth < 600;
    },
    isCreateOrEditPlan() {
      return this.$route.name === 'create-plan' || this.$route.name === "edit-plan"
    }
  },
  methods: {
    ...mapActions(authStore, ['logout', 'returnToAdminAccount']),
    handleLogout() {
      this.logout()
      this.$router.push('/');
    },
    handleGoBackToAdmin() {
      this.returnToAdminAccount();
      this.$router.push('/app/dashboard/admin');
    },
    alternateSidebar() {
      this.showSidebar = !this.showSidebar;
      this.showSupplies = false;
    },
    alternateSupplies() {
      this.showSupplies = !this.showSupplies
    },
    mobileRedirect(where) {
      this.showSidebar = false;
      this.showSupplies = false;
      this.$router.push(`/app${where}`);
    }
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth;
    })
  }
})
</script>

<style scoped>
.n-layout-header {
  position: sticky;
  top: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  padding: 9px 18px;
}

.n-button {
  margin-right: 15px;
}

.n-space {
  margin-left: auto;
}

.responsive-navbar {
  background-color: white;
  width: 100vw;
  height: 80vh;
  position: absolute;
  top: 60px;
  z-index: 500
}

.mobile-navbar-item {
  width: 90vw;
  height: 4vh;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
}

.logout-button {
  background-color: #18A058;
  width: 40vw;
  color: #FFF;
}


@media screen and (max-width: 700px) {
  .isMobile-RARO {
    display: none;
  }
}

@media (max-width: 400px) {
  .logout-button {
    width: 60vw
  }
}
</style>